'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponderByIdAndType = undefined;

var _getters = require('conversations-async-data/indexed-async-data/operators/getters');

var _reselect = require('reselect');

var _buildResponderKey = require('./buildResponderKey');

var getResponderByIdAndType = exports.getResponderByIdAndType = (0, _reselect.defaultMemoize)(function (_ref) {
  var responders = _ref.responders,
      senderId = _ref.senderId,
      senderType = _ref.senderType;

  if (!senderId || !senderType) {
    return null;
  }
  var key = (0, _buildResponderKey.buildResponderKey)({
    senderId: senderId,
    senderType: senderType
  });
  return (0, _getters.getEntry)(key, responders);
});